/* eslint-disable */
import storeApis from "../../api/storeApi";
import * as types from "../../constants/DealRoomActionTypes";
import { toast } from "react-toastify";
import Toast from "../../components/assetLibComponents/shared/Toast";

//SET Unauthorization Status
export const setDRUnauthorized = () => {
  //console.log("setUnauthorizedCALLED");
  return (dispatch) => {
    dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: null });
  };
};

export const setUnauthorizedAssetUpload = () => {
  // console.log("setUnauthorizedAssetUploadCALLED");
  return (dispatch) => {
    dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: null });
  };
};

export const setDRContainerActiveOption = (data) => {
  return (dispatch) => {
    dispatch({ type: types.DEAL_ROOM_CONTAINER_ACTIVE_OPTION, payload: data });
  }
}

//Fetch Deal Room Category List
export const fetchDRTemplateCategoryList = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/categories",
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEAL_ROOM_CATEGORY_LIST,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Template List
export const fetchTemplateList = (authToken, searchKey, categoryType, statusType, sortType) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (statusType === "Bookmarked") {
      try {
        const response = await storeApis.post(
          "bookmarks/list",
          { 
            content_type: "1",
            filters: {
                category: categoryType,
                type: "bookmark"
            } 
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_DEAL_ROOM_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "SEARCH_KEY", payload: searchKey });
            dispatch({ type: "CATEGORY_TYPE", payload: categoryType });
            dispatch({ type: "STATUS_TYPE", payload: statusType });
            dispatch({ type: "SORT_TYPE", payload: sortType });
            dispatch({ type: "QUICK_FILTERS", payload: { id: "Templates" } });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_DEAL_ROOM",
          payload: err.response.status,
        });
      }
    } else {
      try {
        const response = await storeApis.post(
          "templates/list",
          {
            filters: {
              search_keyword: searchKey ? searchKey : "",
              category: categoryType ? [categoryType] : [],
              status: statusType ? statusType : "",
            },
            sort_by: sortType,
            startlimit: 0,
            endlimit: 20,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_DEAL_ROOM_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "SEARCH_KEY", payload: searchKey });
            dispatch({ type: "CATEGORY_TYPE", payload: categoryType });
            dispatch({ type: "STATUS_TYPE", payload: statusType });
            dispatch({ type: "SORT_TYPE", payload: sortType });
            dispatch({ type: "QUICK_FILTERS", payload: { id: "Templates" } });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_DEAL_ROOM",
          payload: err.response.status,
        });
      }
    }
  };
};

//Fetch DealRoom List
export const fetchDealRoomList = (authToken, searchKey, categoryType, statusType, sortType) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (statusType === "Bookmarked") {
      try {
        const response = await storeApis.post(
          "bookmarks/list",
          { 
            content_type: "2",
            filters: {
              category: categoryType ? categoryType : "",
              type: categoryType ? "bookmark" : ""
            } 
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_DEAL_ROOM_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "SEARCH_KEY", payload: searchKey });
            dispatch({ type: "CATEGORY_TYPE", payload: categoryType });
            dispatch({ type: "STATUS_TYPE", payload: statusType });
            dispatch({ type: "SORT_TYPE", payload: sortType });
            dispatch({ type: "QUICK_FILTERS", payload: { id: "Deals" } });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_DEAL_ROOM",
          payload: err.response.status,
        });
      }
    } else {
      try {
        const response = await storeApis.post(
          "deal-room/list",
          {
            filters: {
              search_keyword: searchKey ? searchKey : "",
              category: categoryType ? [categoryType] : [],
              status: statusType ? statusType : "",
            },
            sort_by: sortType,
            startlimit: 0,
            endlimit: 20,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_DEAL_ROOM_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "SEARCH_KEY", payload: searchKey });
            dispatch({ type: "CATEGORY_TYPE", payload: categoryType });
            dispatch({ type: "STATUS_TYPE", payload: statusType });
            dispatch({ type: "SORT_TYPE", payload: sortType });
            dispatch({ type: "QUICK_FILTERS", payload: { id: "Deals" } });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_DEAL_ROOM",
          payload: err.response.status,
        });
      }
    }
  };
};


//Fetch Deal Room List
export const fetchDealRoomList1 = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/list",
        {
          filters: {
            search_keyword: "",
            category: [],
            status: 0,
          },
          sort_by: "0",
          startlimit: 0,
          endlimit: 20,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEAL_ROOM_TEMPLATE_LIST,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Create Deal Room Template
export const createTemplate = (authToken, newTemplateData) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (authToken) {
      try {
        const response = await storeApis.post(
          "templates/add",
          newTemplateData,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            console.log(response.data.message, "E");
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
          } else {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            if (newTemplateData.action === "basic_details") {
              dispatch({
                type: types.CREATED_TEMPLATE_ID,
                payload: response.data.template_id,
              });
            }
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_DEAL_ROOM",
          payload: err.response.status,
        });
        console.log(err.response, "E");
      }
    } else {
      dispatch({ type: types.CREATED_TEMPLATE_ID, payload: null });
    }
  };
};

//Update Deal Room Template Intro
export const UpdateTemplateIntro = (authToken, newTemplateData) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/introduction",
        newTemplateData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchTemplateIntroduction(authToken, newTemplateData?.template_id));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
      console.log(err.response, "E");
    }
  };
};

//Set Deal Room Quick Filter
export const setDealRoomQuickFilter = (authToken, id, type, statusType, sortType) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      if (id === "Bookmarked") {
        const response = await storeApis.post(
          "bookmarks/list",
          { 
            content_type: type === "Deals" ? "2" : "1",
            filters: {
              category: id,
              type: "bookmark"
            }
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_DEAL_ROOM_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({
              type: "QUICK_FILTERS",
              payload: { id: type },
            });
          }
        }
      } else if (type === "Deals") {
        const response = await storeApis.post(
          "deal-room/list",
          {
            filters: {
              search_keyword: "",
              category: [],
              status: 0,
            },
            sort_by: sortType,
            startlimit: 0,
            endlimit: 20,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_DEAL_ROOM_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({
              type: "QUICK_FILTERS",
              payload: { id: type },
            });
          }
        }
      } else if (type === "Templates") {
        const response = await storeApis.post(
          "templates/list",
          {
            filters: {
              search_keyword: "",
              category: [],
              status: 0,
            },
            sort_by: sortType,
            startlimit: 0,
            endlimit: 20,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_DEAL_ROOM_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({
              type: "QUICK_FILTERS",
              payload: { id: type },
            });
          }
        }
      } else {
        const response = await storeApis.post(
          "templates/list",
          {
            filters: {
              search_keyword: "",
              category: id ? [id] : [],
              status: 0,
            },
            sort_by: sortType,
            startlimit: 0,
            endlimit: 20,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_DEAL_ROOM_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({
              type: "QUICK_FILTERS",
              payload: { id: type },
            });
          }
        }
      }
    } catch (err) {
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Template Details
export const fetchTemplateDetails = (authToken, typeID, type) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (type === "deal") {
      try {
        const response = await storeApis.post(
          "deal-room/details",
          { deal_room_id: typeID },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_TEMPLATE_DETAILS,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_DEAL_ROOM",
          payload: err.response.status,
        });
      }
    } else {
      try {
        const response = await storeApis.post(
          "templates/details",
          { template_id: typeID },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_TEMPLATE_DETAILS,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_DEAL_ROOM",
          payload: err.response.status,
        });
      }
    }

  };
};

//DELETE DealRoom Content
export const deleteDealRoomContent = (authToken, asset_id, drType) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (drType === "Templates") {
      try {
        const response = await storeApis.post(
          "templates/remove",
          {
            id: [asset_id],
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            // if (
            //   response.data.message == "Invalid Credentials" ||
            //   response.data.message == "Unauthenticated" ||
            //   response.data.message == "Unauthorized"
            // ) {
            //   dispatch({
            //     type: "UNAUTHORIZED_DEAL_ROOM",
            //     payload: response.data.statusCode,
            //   });
            // } else {
            //   console.log(response.data.message, "E");
            // }
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            // console.log(response.data.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            console.log(response.data.message, "S");
          }
        }
      } catch (err) {
        dispatch({
          type: "UNAUTHORIZED_ASSET_LIBRARY",
          payload: err.response.status,
        });
        console.log(err.response, "S");
      }
    } else if (drType === "Deals") {
      try {
        const response = await storeApis.post(
          "deal-room/remove",
          {
            id: [asset_id],
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            // if (
            //   response.data.message == "Invalid Credentials" ||
            //   response.data.message == "Unauthenticated" ||
            //   response.data.message == "Unauthorized"
            // ) {
            //   dispatch({
            //     type: "UNAUTHORIZED_DEAL_ROOM",
            //     payload: response.data.statusCode,
            //   });
            // } else {
            //   console.log(response.data.message, "E");
            // }
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            // console.log(response.data.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            console.log(response.data.message, "S");
          }
        }
      } catch (err) {
        dispatch({
          type: "UNAUTHORIZED_ASSET_LIBRARY",
          payload: err.response.status,
        });
        console.log(err.response, "S");
      }
    }

  };
};

//PUBLISH DealRoom Template
export const publishDealRoomTemplate = (authToken, asset_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/publish",
        {
          template_id: [asset_id],
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // if (
          //   response.data.message == "Invalid Credentials" ||
          //   response.data.message == "Unauthenticated" ||
          //   response.data.message == "Unauthorized"
          // ) {
          //   dispatch({
          //     type: "UNAUTHORIZED_DEAL_ROOM",
          //     payload: response.data.statusCode,
          //   });
          // } else {
          //   console.log(response.data.message, "E");
          // }
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          // console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
      console.log(err.response, "S");
    }
  };
};

//UNPUBLISH DealRoom Template
export const unpublishDealRoomTemplate = (authToken, asset_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/unpublish",
        {
          template_id: [asset_id],
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // if (
          //   response.data.message == "Invalid Credentials" ||
          //   response.data.message == "Unauthenticated" ||
          //   response.data.message == "Unauthorized"
          // ) {
          //   dispatch({
          //     type: "UNAUTHORIZED_DEAL_ROOM",
          //     payload: response.data.statusCode,
          //   });
          // } else {
          //   console.log(response.data.message, "E");
          // }
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          // console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
      console.log(err.response, "S");
    }
  };
};

//DUPLICATE DealRoom
export const duplicateDealRoom = (authToken, asset_id, drType) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (drType === "Templates") {
      try {
        const response = await storeApis.post(
          "templates/duplicate",
          {
            template_id: asset_id,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            // if (
            //   response.data.message == "Invalid Credentials" ||
            //   response.data.message == "Unauthenticated" ||
            //   response.data.message == "Unauthorized"
            // ) {
            //   dispatch({
            //     type: "UNAUTHORIZED_DEAL_ROOM",
            //     payload: response.data.statusCode,
            //   });
            // } else {
            //   console.log(response.data.message, "E");
            // }
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            // console.log(response.data.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            console.log(response.data.message, "S");
          }
        }
      } catch (err) {
        dispatch({
          type: "UNAUTHORIZED_ASSET_LIBRARY",
          payload: err.response.status,
        });
        console.log(err.response, "S");
      }
    } else if (drType === "Deals") {
      try {
        const response = await storeApis.post(
          "deal-room/duplicate",
          {
            deal_room_id: asset_id,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            // if (
            //   response.data.message == "Invalid Credentials" ||
            //   response.data.message == "Unauthenticated" ||
            //   response.data.message == "Unauthorized"
            // ) {
            //   dispatch({
            //     type: "UNAUTHORIZED_DEAL_ROOM",
            //     payload: response.data.statusCode,
            //   });
            // } else {
            //   console.log(response.data.message, "E");
            // }
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            // console.log(response.data.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            console.log(response.data.message, "S");
          }
        }
      } catch (err) {
        dispatch({
          type: "UNAUTHORIZED_ASSET_LIBRARY",
          payload: err.response.status,
        });
        console.log(err.response, "S");
      }
    }
  };
};

//BOOKMARK DealRoom
export const bookmarkDealRoom = (authToken, asset_id, action, type) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        `bookmarks/${action}`,
        {
          content_id: asset_id,
          content_type: type === "Deals" ? 2 : 1
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // if (
          //   response.data.message == "Invalid Credentials" ||
          //   response.data.message == "Unauthenticated" ||
          //   response.data.message == "Unauthorized"
          // ) {
          //   dispatch({
          //     type: "UNAUTHORIZED_DEAL_ROOM",
          //     payload: response.data.statusCode,
          //   });
          // } else {
          //   console.log(response.data.message, "E");
          // }
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          // console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
        }
      }
    } catch (err) {
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
      console.log(err.response, "S");
    }
  };
};

//Fetch Template Introduction
export const fetchTemplateIntroduction = (authToken, templateID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/introduction",
        { action: "get_introduction", template_id: templateID },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_TEMPLATE_INTRODUCTION,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Template Section
export const fetchTemplateSection = (authToken, templateID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/section",
        { action: "section_list", template_id: templateID },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_TEMPLATE_SECTION,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Add Template Section
export const addTemplateSection = (authToken, templateID, newSection) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/section",
        { action: "section", template_id: templateID, sections: newSection },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchTemplateSection(authToken, templateID));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Remove Template Section
export const removeTemplateSection = (authToken, templateID, sectionID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/section",
        {
          action: "delete_section",
          template_id: templateID,
          section_id: sectionID,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchTemplateSection(authToken, templateID));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Update Template Section Title
export const updateTemplateSectionTitle = (
  authToken,
  templateID,
  sectionID,
  newTitle
) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/section",
        {
          action: "section",
          template_id: templateID,
          //section_id: sectionID,
          //title: newTitle,
          sections: [
            {section_id: sectionID, title: newTitle }
          ]
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch({ type: "EDIT_SECTION_TITLE_STATUS", payload: true });
          dispatch(fetchTemplateSection(authToken, templateID))
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Deal Room Section Asset List
export const fetchSectionAssetList = (authToken, templateID, sectionID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/section",
        {
          action: "asset_list",
          template_id: templateID,
          section_id: sectionID,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_SECTION_ASSET_LIST,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.statusCode,
      });
    }
  };
};

//Check Section Asset Selected
export const sectionAssetSelected = (contentList) => {
  return async (dispatch) => {
    dispatch({ type: "SECTION_ASSET_SELECTED", payload: contentList });
  };
};

//Add Section Asset Selected
export const addSectionAssetSelected = (
  authToken,
  templateID,
  sectionID,
  selectedAsset
) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/section",
        {
          action: "add_asset",
          template_id: templateID,
          section_id: sectionID,
          asset_ids: selectedAsset,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Remove Section Asset
export const removeSectionAsset = (authToken, templateID, assetID, sectionId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/section",
        {
          action: "delete_asset",
          template_id: templateID,
          asset_id: assetID,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchSectionAssetList(authToken, templateID, sectionId));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Update Section Asset Title
export const updateSectionAssetTitle = (authToken, templateID, assetID, newAssetTitle, sectionID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/section",
        {
          action: "update_asset_title",
          template_id: templateID,
          asset_id: assetID,
          name: newAssetTitle,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchSectionAssetList(authToken, templateID, sectionID));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Template Setup
export const fetchTemplateSetup = (authToken, templateID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "templates/setup",
        { action: "get_setup", template_id: templateID },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_TEMPLATE_SETUP,
            payload: response.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Update Deal Room Template Setup
export const updateTemplateSetup = (authToken, newSetupData) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post("templates/setup", newSetupData, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchTemplateDetails(authToken, newSetupData?.template_id));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
      console.log(err.response, "E");
    }
  };
};

//Publish Deal Room Template
export const publishTemplate = (authToken, templateID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (authToken) {
      try {
        const response = await storeApis.post(
          "templates/publish",
          { template_id: [templateID] },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // console.log(response.data.message, "E");
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
          } else {
            dispatch({ type: "PUBLISH_STATUS", payload: true });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            console.log(response.data.message, "S");
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_DEAL_ROOM",
          payload: err.response.status,
        });
        console.log(err.response, "E");
      }
    } else {
      dispatch({ type: "PUBLISH_STATUS", payload: false });
    }
  };
};

//Unpublish Deal Room Template
export const unpublishTemplate = (authToken, templateID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (authToken) {
      try {
        const response = await storeApis.post(
          "templates/unpublish",
          { template_id: [templateID] },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // console.log(response.data.message, "E");
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
          } else {
            dispatch({ type: "PUBLISH_STATUS", payload: true });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            console.log(response.data.message, "S");
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_DEAL_ROOM",
          payload: err.response.status,
        });
        console.log(err.response, "E");
      }
    } else {
      dispatch({ type: "PUBLISH_STATUS", payload: false });
    }
  };
};

//Fetch Search Content List
export const fetchSearchContentList = (authToken, searchKey) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      if (searchKey) {
        const response = await storeApis.post(
          "templates/list",
          {
            filters: {
              search_keyword: searchKey,
              category: [null],
              status: 0,
            },
            sort_by: "0",
            startlimit: 0,
            endlimit: 20,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_DEAL_ROOM_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({
              type: "QUICK_FILTERS",
              payload: { id: null, value: null },
            });
          }
        }
      } else {
        const response = await storeApis.post(
          "templates/list",
          {
            filters: {
              search_keyword: "",
              category: [null],
              status: 0,
            },
            sort_by: "0",
            startlimit: 0,
            endlimit: 20,
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
          } else {
            dispatch({
              type: types.FETCH_DEAL_ROOM_CONTENT_LIST,
              payload: response.data.data,
            });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({
              type: "QUICK_FILTERS",
              payload: { id: null, value: null },
            });
          }
        }
      }
    } catch (err) {
      dispatch({
        type: "UNAUTHORIZED_ASSET_LIBRARY",
        payload: err.response.status,
      });
    }
  };
};

//Set Section Asset IgnoreIDs
export const setIgnoreIDs = (ids) => {
  return async (dispatch) => {
    dispatch({ type: "SET_IGNORE_IDS", payload: ids });
  };
};

//Set Template ID
export const setTemplateID = (template_id) => {
  return async (dispatch) => {
    dispatch({
      type: "CREATED_TEMPLATE_ID",
      payload: template_id,
    });
  };
};

//Create Deal Room Deal
export const createDeal = (authToken, newDealData) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (authToken) {
      try {
        const response = await storeApis.post("deal-room/add", newDealData, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // console.log(response.data.message, "E");
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
          } else {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({
              type: types.CREATED_DEAL_ID,
              payload: response.data.deal_room_id,
            });
            console.log(response.data.message, "S");
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_DEAL_ROOM",
          payload: err.response.status,
        });
        console.log(err.response, "E");
      }
    } else {
      dispatch({ type: types.CREATED_DEAL_ID, payload: null });
    }
  };
};

//Set Deal ID
export const setDealID = (deal_id) => {
  return async (dispatch) => {
    dispatch({
      type: "CREATED_DEAL_ID",
      payload: deal_id,
    });
  };
};



//Update Deal Setup
export const updateDealSetup = (authToken, body) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/setup",
        body,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          console.log(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          //dispatch(fetchDealSetup(authToken, body?.deal_room_id));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
      console.log(err.response.data.message, "E");
    }
  };
};

//Fetch Deal Room Template/Deal Categories
export const fetchDRDealCategories = (authToken, dealId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/categories",
        null,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEAL_ROOM_CATEGORY_LIST,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Deal Setup
export const fetchDealSetup = (authToken, dealId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/setup",
        { action: "get_setup", deal_room_id: dealId },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEAL_SETUP,
            payload: response.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Deal access list
export const fetchDealAccessList = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "accounts/list",
        null,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEAL_ACCESS_LIST,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//fetch deal buyers list
export const fetchDealBuyersList = (authToken, accountId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "accounts/contacts",
        { account_id: accountId },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEAL_BUYERS_LIST,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//fetch deal sellers list
export const fetchDealSellersList = (authToken, clientId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "users/list",
        null, /* { client_id: clientId } */
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEAL_SELLERS_LIST,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Deal Introduction
export const fetchDealIntroduction = (authToken, dealID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/introduction",
        { action: "get_introduction", deal_room_id: dealID },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEAL_INTRODUCTION,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};


//Update Deal Room Template Intro
export const UpdateDealIntro = (authToken, newTemplateData) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/introduction",
        newTemplateData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchDealIntroduction(authToken, newTemplateData?.deal_room_id));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
      console.log(err.response, "E");
    }
  };
};

//fetch deal room details
export const fetchDealDetails = (authToken, dealId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/details",
        { deal_room_id: dealId },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEAL_DETAILS,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Template Section
export const fetchDealSection = (authToken, dealID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/section",
        { action: "section_list", deal_room_id: dealID },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEAL_SECTION,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Add Template Section
export const addDealSection = (authToken, dealID, newSection) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/section",
        { action: "section", deal_room_id: dealID, sections: newSection },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchDealSection(authToken, dealID));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};


//asset related 
//Remove Template Section
export const removeDealSection = (authToken, dealID, sectionID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/section",
        {
          action: "delete_section",
          deal_room_id: dealID,
          section_id: sectionID,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchDealSection(authToken, dealID));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Update Deal Section Title
export const updateDealSectionTitle = (authToken, dealID, sectionID, newTitle) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/section",
        {
          action: "section",
          deal_room_id: dealID,
          // section_id: sectionID,
          // title: newTitle, 
          sections: [
            {section_id: sectionID, title: newTitle }
          ]
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          console.log("response>>",response.data);
          dispatch({ type: "EDIT_SECTION_TITLE_STATUS", payload: true });
          dispatch(fetchDealSection(authToken, dealID))
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Fetch Deal Room Section Asset List
export const fetchDealSectionAssetList = (authToken, dealID, sectionID) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/section",
        {
          action: "asset_list",
          deal_room_id: dealID,
          section_id: sectionID,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_SECTION_ASSET_LIST,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.statusCode,
      });
    }
  };
};

//Check Section Asset Selected
/* export const sectionAssetSelected = (contentList) => {
  return async (dispatch) => {
    dispatch({ type: "SECTION_ASSET_SELECTED", payload: contentList });
  };
};
*/

//Add Section Asset Selected
export const addDealSectionAssetSelected = (authToken, dealID, sectionID, selectedAsset) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/section",
        {
          action: "add_asset",
          deal_room_id: dealID,
          section_id: sectionID,
          asset_ids: selectedAsset,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Remove Deal Section Asset
export const removeDealSectionAsset = (authToken, dealID, assetID, sectionId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/section",
        {
          action: "delete_asset",
          deal_room_id: dealID,
          asset_id: assetID,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchDealSectionAssetList(authToken, dealID, sectionId));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Update Section Asset Title
export const updateDealSectionAssetTitle = (authToken, dealID, assetID, newAssetTitle, sectionId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/section",
        {
          action: "update_asset_title",
          deal_room_id: dealID,
          asset_id: assetID,
          name: newAssetTitle,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchDealSectionAssetList(authToken, dealID, sectionId));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Publish Deal Room Template
export const dealGoLive = (authToken, dealRoomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (authToken) {
      try {
        const response = await storeApis.post(
          "deal-room/go-live",
          { deal_room_id: dealRoomId },
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // console.log(response.data.message, "E");
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
          } else {
            dispatch({ type: "GO_LIVE_STATUS", payload: true });
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            console.log(response.data.message, "S");
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({
          type: "UNAUTHORIZED_DEAL_ROOM",
          payload: err.response.status,
        });
        console.log(err.response, "E");
      }
    } else {
      dispatch({ type: "GO_LIVE_STATUS", payload: false });
    }
  };
};



//get timeline 
export const getTimelineList = (authToken, filterVal, dealRoomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "timeline/list",
        { action: "date", filter: filterVal, deal_room_id: dealRoomId },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: types.GET_TIMELINE_LIST, payload: response.data?.data?.data });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};


//get deal room timeline recap list
export const getTimelineRecapList = (authToken, dealRoomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "timeline/recap",
        {
          action: "", //if you want the response like tmline then pass "date" in action 
          dealroom_id: dealRoomId
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: types.GET_TIMELINE_RECAP_LIST, payload: response.data?.data?.data });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};


//add or remove timeline to recap list
export const addTimelineRecap = (authToken, actionName, thId, dealroomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "timeline/add-recap",
        {
          action: actionName, //add or remove are the actions
          th_id: thId
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch(getTimelineList(authToken, "", dealroomId));
          dispatch(getTimelineRecapList(authToken, dealroomId));
          console.log(response.data.message, "S");
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};

//edit timeline
export const editTimeline = (authToken, actionName, thId, dealroomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "timeline/edit",
        {
          action: actionName, //hide  or show are the actions
          th_id: thId
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch(getTimelineList(authToken, "", dealroomId));
          console.log(response.data.message, "S");
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};




//get deal room timeline recap list
export const getDRSelectedContacts = (authToken, dealRoomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/contacts",
        {
          action: "", //if you want the response like tmline then pass "date" in action 
          deal_room_id: dealRoomId
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: types.GET_DEALROOM_CONTACTS_LIST, payload: response.data?.data });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};


//sendMail to dealroom contacts
export const sendMailToDRContacts = (authToken, reqBody) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    if (authToken) {
      try {
        const response = await storeApis.post(
          "deal-room/share-email",
          reqBody,
          {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.status === 200) {
          if (response.data.statusCode == "403") {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            // console.log(response.data.message, "E");
            dispatch({
              type: "UNAUTHORIZED_DEAL_ROOM",
              payload: response.data.statusCode,
            });
          } else {
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            console.log(response.data.message, "S");
            dispatch({ type: types.SEND_MAIL_TO_DEALROOM_CONTACTS_STATUS, payload: true });
          }
        }
      } catch (err) {
        // console.log("ERROR", err);
        dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
        console.log(err.response, "E");
      }
    } else {
      dispatch({ type: types.SEND_MAIL_TO_DEALROOM_CONTACTS_STATUS, payload: false });
    }
  };
};


//sendMail to dealroom contacts
export const DRClientInvite = (authToken, mailId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/invite",
        { invite_to: mailId },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      console.log(err.response, "E");
    }
  };
};



//scheduled Meeting list
export const fetchZoomMeetingLink = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "meetings/fetch-url",
        null,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({ type: "GET_ZOOM_MEETING_LINK", payload: response.data.url });
        }
      }
    } catch (err) {
      console.log(err.response, "E");
    }
  };
};

//scheduled Meeting list
export const scheduleNewMeeting = (authToken, meetingDetails) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "meetings/schedule",
        meetingDetails,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({ type: "SET_ZOOM_CODE", payload: null });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({ type: "SET_ZOOM_CODE", payload: null });
          console.log(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log(err.response, "E");
    }
  };
};

//scheduled Meeting list
export const scheduledMeetingsList = (authToken, drId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "meetings/list",
        { deal_room_id: drId },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          //console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else if (response.data.statusCode == "303") {
          dispatch({ type: "SCHEDULED_MEETINGS_LIST", payload: null });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({ type: "SCHEDULED_MEETINGS_LIST", payload: response?.data?.data });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      console.log(err.response, "E");
    }
  };
};




/* milestone releated apis */
//fetch mailstones list 
export const fetchMilestoneList = (authToken, dealRoomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "milestones/list",
        { deal_room_id: dealRoomId },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          //console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({ type: types.GET_MILESTONES_LIST, payload: response.data.data });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};

//add milestone
export const addNewMilestone = (authToken, dealRoomId, milestoneName) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "milestones/add",
        {
          deal_room_id: dealRoomId,
          title: milestoneName
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchMilestoneList(authToken, dealRoomId));
        }
      }
    } catch (err) {
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};

//add milestone goal
export const addMilestoneGoal = (authToken, type, milestoneId, goalName, assigns, link, dealroomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "milestones/add-goals",
        {
          type: type,
          milestone_id: milestoneId,
          goal_name: goalName,
          asign: assigns,
          link: link
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchMilestoneList(authToken, dealroomId))
        }
      }
    } catch (err) {
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};

//update milestone
export const updateMilestone = (authToken, milestoneId, milestoneName, dealroomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "milestones/update",
        {
          milestone_id: milestoneId,
          milestone_name: milestoneName
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchMilestoneList(authToken, dealroomId));
        }
      }
    } catch (err) {
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};

//update milestone
export const updateMilestoneGoal = (authToken, goalId, goalName, assigns,link, dealroomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "milestones/update-goals",
        {
          goal_id: goalId,
          goal_name: goalName,
          asign: assigns,
          link: link
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchMilestoneList(authToken, dealroomId));
        }
      }
    } catch (err) {
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};

//remove milestone or goal
export const deleteMilestoneOrGoal = (authToken, type, id, dealroomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "milestones/remove",
        {
          type: type,
          id: id
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          console.log(response.data.message, "S");
          dispatch(fetchMilestoneList(authToken, dealroomId));
        }
      }
    } catch (err) {
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};


//get milestone client douments list BE
export const getClientDocumentsListBE = (authToken, dealRoomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "milestones/document-list",
        null,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else if (response.data.statusCode == "303") {
          //console.log("There are no Client Documents Availale", "W");
        } else {
          dispatch({ type: types.GET_MILESTONE_CLIENT_DOCUMENT_LIST, payload: response.data?.data });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};




/* dealRoom FE APIS */
//fetch deal room details - FRONTEND VIEW
export const fetchDealDetailsFE = (authToken, dealId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/fetch-details",
        { deal_room_id: dealId },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEAL_DETAILS,
            payload: response.data.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//scheduled Meeting list FRONTEND VIEW
export const scheduledMeetingsListFE = (authToken, drId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "meetings/fetch-list",
        { deal_room_id: drId },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else if (response.data.statusCode == "303") {
          dispatch({ type: "SCHEDULED_MEETINGS_LIST", payload: null });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({ type: "SCHEDULED_MEETINGS_LIST", payload: response?.data?.data });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      console.log(err.response, "E");
    }
  };
};

//get timeline FRONTEND VIEW
export const getTimelineListFE = (authToken, filterVal, dealRoomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "timeline/fetch-list",
        { action: "date", filter: filterVal, deal_room_id: dealRoomId },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: types.GET_TIMELINE_LIST, payload: response.data?.data?.data });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};


//get deal room timeline recap list FRONTEND VIEW
export const getTimelineRecapListFE = (authToken, dealRoomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "timeline/fetch-recap",
        {
          action: "", //if you want the response like tmline then pass "date" in action 
          dealroom_id: dealRoomId
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: types.GET_TIMELINE_RECAP_LIST, payload: response.data?.data?.data });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};

//get milestone client douments list
export const getClientDocumentsListFE = (authToken, dealRoomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "milestones/doc-list",
        null,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: types.GET_MILESTONE_CLIENT_DOCUMENT_LIST, payload: response.data?.data });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};

//get FE MilestonesList
export const getMilestonesListFE = (authToken, dealRoomId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "milestones/fetch-list",
        null,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          dispatch({ type: types.GET_MILESTONES_LIST, payload: response.data?.data }); //GET_MILESTONES_LIST_FRONTEND
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};

//add FE Milestones goal activity
export const addGoalActivity = (authToken, goalId, type, data) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "milestones/activity",
        {
          goal_id: goalId,
          type: type,
          data: data
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          console.log(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch(getMilestonesListFE(authToken));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};

//upload client docs for milestones
export const uploadClientDocument = (authToken, goalId, type, data) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "milestones/upload-doc",
        {
          type: type,
          doc: data
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // console.log(response.data.message, "E");
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
        } else {
          console.log(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch(getClientDocumentsListFE(authToken));
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({ type: "UNAUTHORIZED_DEAL_ROOM", payload: err.response.status });
      console.log(err.response, "E");
    }
  };
};

//fetch deal room comments - FRONTEND VIEW
export const fetchDealRoomComments = (authToken, dealId, asset_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "buyer-deal-room/comments/list",
        {
          deal_room_id: dealId,
          deal_room_assets_id: asset_id
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEALROOM_COMMENTS,
            payload: response.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Set deal room comments - FRONTEND VIEW
export const setDealRoomComments = (authToken, deal_id, asset_id, cmt_body, page_id, parent_cmt_id, cmt_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "buyer-deal-room/comments/add",
        {
          deal_room_id: deal_id,
          deal_room_assets_id: asset_id,
          body: cmt_body,
          pdf_page_id: page_id,
          parent_comment_id: parent_cmt_id
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          // console.log(response.data.response, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          console.log(response.data.response, "S");
          dispatch(fetchDealRoomComments(authToken, deal_id, asset_id));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Delete deal room comments - FRONTEND VIEW
export const deleteDealRoomComments = (authToken, cmt_id, deal_id, asset_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "buyer-deal-room/comments/delete",
        {
          comment_id: cmt_id
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          // console.log(response.data.response, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          console.log(response.data.response, "S");
          dispatch(fetchDealRoomComments(authToken, deal_id, asset_id));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Edit deal room comments - FRONTEND VIEW
export const editDealRoomComments = (authToken, cmt_id, cmt_body, deal_id, asset_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "buyer-deal-room/comments/edit",
        {
          comment_id: cmt_id,
          body: cmt_body
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          // console.log(response.data.response, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          console.log(response.data.response, "S");
          dispatch(fetchDealRoomComments(authToken, deal_id, asset_id));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//fetch deal room comments - FRONTEND VIEW
export const fetchDealRoomCommentsBE = (authToken, dealId, asset_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/comments/list",
        {
          deal_room_id: dealId,
          deal_room_assets_id: asset_id
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_DEALROOM_COMMENTS,
            payload: response.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Set deal room comments - FRONTEND VIEW
export const setDealRoomCommentsBE = (authToken, deal_id, asset_id, cmt_body, page_id, parent_cmt_id, cmt_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/comments/add",
        {
          deal_room_id: deal_id,
          deal_room_assets_id: asset_id,
          body: cmt_body,
          pdf_page_id: page_id,
          parent_comment_id: parent_cmt_id ? parent_cmt_id : cmt_id
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          // console.log(response.data.response, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          console.log(response.data.response, "S");
          dispatch(fetchDealRoomCommentsBE(authToken, deal_id, asset_id));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Delete deal room comments - FRONTEND VIEW
export const deleteDealRoomCommentsBE = (authToken, cmt_id, deal_id, asset_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/comments/delete",
        {
          comment_id: cmt_id
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          // console.log(response.data.response, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          console.log(response.data.response, "S");
          dispatch(fetchDealRoomCommentsBE(authToken, deal_id, asset_id));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Edit deal room comments - FRONTEND VIEW
export const editDealRoomCommentsBE = (authToken, cmt_id, cmt_body, deal_id, asset_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "deal-room/comments/edit",
        {
          comment_id: cmt_id,
          body: cmt_body
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          // console.log(response.data.response, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          console.log(response.data.response, "S");
          dispatch(fetchDealRoomCommentsBE(authToken, deal_id, asset_id));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};

//Update Sort Order
export const updateSortOrder = (authToken, sort_order, sort_order_type) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "sort_order",
        {
          action: sort_order_type,
          items: sort_order
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_DEAL_ROOM",
            payload: response.data.statusCode,
          });
          // console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          console.log(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      // console.log("ERROR", err);
      dispatch({
        type: "UNAUTHORIZED_DEAL_ROOM",
        payload: err.response.status,
      });
    }
  };
};